/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request object for an institute phone
 * @export
 * @interface InstitutePhoneRequest
 */
export interface InstitutePhoneRequest {
    /**
     * true if the email is a mobile number
     * @type {boolean}
     * @memberof InstitutePhoneRequest
     */
    isMobile?: boolean;
    /**
     * number og the institute phone
     * @type {string}
     * @memberof InstitutePhoneRequest
     */
    number?: string;
    /**
     * the prefix of the phone
     * @type {string}
     * @memberof InstitutePhoneRequest
     */
    phonePrefix?: string;
}

/**
 * Check if a given object implements the InstitutePhoneRequest interface.
 */
export function instanceOfInstitutePhoneRequest(value: object): value is InstitutePhoneRequest {
    return true;
}

export function InstitutePhoneRequestFromJSON(json: any): InstitutePhoneRequest {
    return InstitutePhoneRequestFromJSONTyped(json, false);
}

export function InstitutePhoneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstitutePhoneRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'isMobile': json['isMobile'] == null ? undefined : json['isMobile'],
        'number': json['number'] == null ? undefined : json['number'],
        'phonePrefix': json['phonePrefix'] == null ? undefined : json['phonePrefix'],
    };
}

export function InstitutePhoneRequestToJSON(json: any): InstitutePhoneRequest {
    return InstitutePhoneRequestToJSONTyped(json, false);
}

export function InstitutePhoneRequestToJSONTyped(value?: InstitutePhoneRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isMobile': value['isMobile'],
        'number': value['number'],
        'phonePrefix': value['phonePrefix'],
    };
}

